import { ApolloProvider } from '@apollo/client/react';

import Sidebar from '../features/layout/sidebar/Sidebar';
import { client } from '../graphql/client';

type Props = {
  employerId: string;
};

export const SidebarApp: React.FC<Props> = props => {
  const { employerId } = props;
  return (
    <ApolloProvider client={client}>
      <Sidebar employerId={employerId} />
    </ApolloProvider>
  );
};
